import { Badge } from 'antd';
import { PresetStatusColorType } from 'antd/es/_util/colors';
import { TicketStatus, TicketStatusTitle } from '../../../store/ticket';

const BadgeTicketStatusValue: Record<TicketStatus, PresetStatusColorType> = {
  [TicketStatus.OPEN]: 'error',
  [TicketStatus.IN_PROGRESS]: 'processing',
  [TicketStatus.RESOLVED]: 'default',
};

interface BadgeTicketStatusProps {
  status?: TicketStatus;
}

export default function BadgeTicketStatus({ status }: BadgeTicketStatusProps) {
  return status ? <Badge status={BadgeTicketStatusValue[status]} text={TicketStatusTitle[status]} /> : null;
}
